<template>
	<div>
		<v-tabs v-model="tab" vertical>
			<v-tab key="General">{{ $t("general") }}</v-tab>
			<v-tab v-if="value.typeData == 3" key="Combo">Combo</v-tab>

			<v-tabs-slider></v-tabs-slider>

			<v-tabs-items v-model="tab">
				<v-tab-item key="General">
					<v-container>
						<v-form v-model="valid" ref="form">
							<v-text-field
								v-model="value.label"
								:label="$t('entities.regTypeFields.props.label')"
								:rules="$isRequiredRule"
							></v-text-field>
							<v-text-field
								v-model="value.seq"
								:label="$t('entities.regTypeFields.props.seq')"
							></v-text-field>

							<v-select
								v-model="value.typeData"
								:items="$typesData"
								item-text="value"
								item-value="key"
								:label="$t('entities.regTypeFields.props.typeData')"
								clearable
								:rules="[ruleTypeData]"
							></v-select>

							<auto-complete-entity
								v-if="value.typeData == 9"
								ref="itemId"
								v-model="value.parameterItemId"
								entityApi="item"
								:itemPreSelected="selectedItem"
								itemText="description"
								itemValue="id"
								:label="$t('entities.regTypeFields.props.parameterItemId')"
								:clearable="true"
								:rules="value.typeData == 9 ? $isRequiredRule : []"
							/>

							<v-text-field
								v-if="value.typeData == 0 || value.typeData == 7"
								v-model="value.length"
								:label="
									value.typeData == 0
										? $t('entities.regTypeFields.props.length')
										: $t('height')
								"
								type="numeric"
								:rules="value.typeData == 0 ? $isRequiredRule : []"
							></v-text-field>

							<v-text-field
								v-if="value.typeData == 4"
								v-model="value.variableKey"
								:label="$t('entities.regTypeFields.props.variableKey')"
								type="text"
								:rules="value.typeData == 4 ? $isRequiredRule : []"
							></v-text-field>

							<v-select
								v-if="value.typeData == 4"
								v-model="value.variableType"
								:items="$typesDataNative"
								item-text="value"
								item-value="key"
								:label="$t('entities.regTypeFields.props.variableType')"
							></v-select>

							<v-checkbox
								v-if="value.typeData == 4"
								:label="$t('entities.regTypeFields.props.readOnly')"
								v-model="value.readOnly"
							/>
							<v-select
								v-model="value.behavior"
								:items="$behaviors"
								item-text="value"
								item-value="key"
								:label="$t('entities.regTypeFields.props.behavior')"
								clearable
							></v-select>
							<v-select
								v-model="value.readType"
								:items="$readTypes"
								item-text="value"
								item-value="value"
								:label="$t('entities.regTypeFields.props.readType')"
								clearable
							></v-select>
							<v-checkbox
								:label="$t('entities.regTypeFields.props.required')"
								v-model="value.isRequired"
							/>
						</v-form>
					</v-container>
				</v-tab-item>
				
				<v-tab-item key="Combo">
					<v-container>
						<btn-a
							class="ma-2"
							outlined
							rounded
							color="primary"
							@click="comboDialogOpen"
						>
							<v-icon>mdi-plus</v-icon>
						</btn-a>
						<v-list v-if="value.combo">
							<div v-for="(item, i) in value.combo" :key="i">
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title v-text="item"></v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn icon @click="comboDialogOpen(item)">
											<v-icon color="warning">mdi-pencil</v-icon>
										</v-btn>
									</v-list-item-action>
									<v-list-item-action>
										<v-btn icon @click="comboRemove(item)">
											<v-icon color="error">mdi-delete</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
								<v-divider
									v-if="value.combo && value.combo.length > 0"
								></v-divider>
							</div>
						</v-list>
						<dialog-d
							ref="comboDialog"
							title="Combo"
							@confirm="comboConfirm"
							@cancel="comboDialogCancel"
						>
							<v-form ref="comboForm" v-model="comboValid">
								<v-text-field
									v-model="comboSelected"
									:label="$t('entities.regTypeFields.props.optionLabel')"
									:rules="$isRequiredRule"
								></v-text-field>
							</v-form>
						</dialog-d>
					</v-container>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>
<script>
	import itemService from "../../../services/itemService";

	export default {
		props: {
			value: {
				default() {
					return {
						label: "",
						seq: 0,
						length: 0,
						isRequired: false,
						typeData: "",
						behavior: "",
						combo: [],
					};
				},
			},
		},
		watch: {
			value() {
				this.$refs.form.resetValidation();
			},
			comboSelected() {
				this.$refs.comboForm.resetValidation();
			},
		},
		data() {
			return {
				valid: true,
				comboValid: true,
				selectedItem: null,
				tab: null,
				comboSelected: "",
				comboSelectedRef: null,
			};
		},
		methods: {
			isValid() {
				return this.$refs.form.validate();
			},
			ruleTypeData() {
				return this.value.typeData != null || "Field is required";
			},
			comboDialogCancel() {
				this.comboSelectedRef = null;
			},
			comboConfirm() {
				if (!this.$refs.comboForm.validate()) return;
				if (this.comboSelectedRef != null) {
					let index = this.value.combo.indexOf(this.comboSelectedRef);
					this.value.combo[index] = this.comboSelected.toString();
					this.$forceUpdate();
				} else {
					this.value.combo.push(this.comboSelected);
				}
				this.$refs.comboDialog.open();
				this.comboSelectedRef = null;
			},
			async comboRemove(combo) {
				if (!(await this.$confirm())) return;
				let index = this.value.combo.indexOf(combo);
				if (index >= 0) this.value.combo.splice(index, 1);
			},
			comboDialogOpen(combo) {
				if (combo) {
					this.comboSelectedRef = combo;
					let obj = combo.toString();
					this.comboSelected = obj;
				} else {
					this.comboSelected = "";
				}

				this.$refs.comboDialog.open();
			},
			async getParameterItem() {
				if (!this.value.typeData == 9) return;
				let res = await itemService.getById(this.value.parameterItemId);
				if (res.success) this.selectedItem = res.data;
			},
		},
		async mounted() {
			await this.getParameterItem();
		},
		created() {},
	};
</script>
